import { render } from "./new.vue?vue&type=template&id=d53e7484&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=d53e7484&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53e7484"]])

export default __exports__